import { IconDefinition, IconPack, library, config } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";

config.autoAddCss = false;
library.add(
  // brands,
  faGoogle as IconDefinition,
  fas as IconPack,
  fal as IconPack,
  far as IconPack
);
